var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillsBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 88,
    viewBox: "0 0 402 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_45_191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401 86.4141H1V27.8161L31.0578 1H204.468L220.113 25.2416H401V86.4141Z",
    fill: "#040404",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 86.4141H1V27.8161L31.0578 1H204.468L220.113 25.2416H401V86.4141Z",
    stroke: "#A0A0A0",
    strokeWidth: 1.3046
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_45_191",
    x: -4.87073,
    y: -4.87073,
    width: 411.741,
    height: 97.1555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.60919
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_45_191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_45_191",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsBorder);
export default __webpack_public_path__ + "static/media/skillsBorder.048d61848cd06c8ab1cbedb96da5a691.svg";
export { ForwardRef as ReactComponent };